import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import "./loader.scss";

const Loader = ({message = ''}) => {
  return (
    <div style={{ textAlign: "center", marginTop: "20%" }}>
      <Box className="loader-container">
        <CircularProgress color="primary" />
      </Box>
      <p style={{ marginTop: "1rem", fontSize: "1.1rem" }}>
        {message}
      </p>
    </div>
  );
};

export default Loader;
